import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getDyeHouse, getNext, createDyeHouse, updateDyeHouse, handleSearch } from "./thunk";

const initialState = {
  dyeHouses: [],
  edit: false,
  dyeHouse: null,
  count: null,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingDyeHouse: false,
  loadingNext: false,
};

export const dyeHouseSlice = createSlice({
  name: "dyeHouse",
  initialState,
  reducers: {
    dyeHouseEditSuccess: (state, action) => {
      state.edit = true;
      state.dyeHouse = state.dyeHouses.find((dyeHouse) => dyeHouse.id === action.payload);
    },
    clearAllDyeHouse: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingDyeHouse = false;
      state.dyeHouse = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNext.pending, (state) => {
      state.loadingNext = true;
    });
    builder.addCase(getNext.fulfilled, (state, action) => {
      state.loadingNext = false;
      state.dyeHouses = [...state.dyeHouses, ...action.payload.results];
      state.next = action.payload.next;
    });
    builder.addCase(getNext.rejected, (state) => {
      state.loadingNext = false;
    });
    builder.addCase(createDyeHouse.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createDyeHouse.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createDyeHouse.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateDyeHouse.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateDyeHouse.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateDyeHouse.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(isAnyOf(getDyeHouse.pending, handleSearch.pending), (state) => {
      state.loadingDyeHouse = true;
    });
    builder.addMatcher(isAnyOf(getDyeHouse.fulfilled, handleSearch.fulfilled), (state, action) => {
      state.loadingDyeHouse = false;
      state.dyeHouses = action.payload.results;
      state.count = action.payload.count;
      state.previous = action.payload.previous;
      state.next = action.payload.next;
    });
    builder.addMatcher(isAnyOf(getDyeHouse.rejected, handleSearch.rejected), (state) => {
      state.loadingDyeHouse = false;
    });
  },
});

export const { dyeHouseEditSuccess, clearAllDyeHouse } = dyeHouseSlice.actions;

export default dyeHouseSlice.reducer;
